export default {
  title: 'Clientes',
  description: 'Gerencie as empresas e organizações cadastradas no ecossistema Núcleo P, seus dados cadastrais, proprietários, usuários, produtos, módulos e acessos.',
  labels: {
    new: 'Novo cliente'
  },
  owners: {
    labels: {
      new: 'Vincular proprietário'
    }
  },
  owner_requests: {
    labels: {
      new: 'Transferir propriedade'
    }
  },
  tenant_products: {
    labels: {
      new: 'Vincular produto'
    }
  },
  tenant_modules: {
    labels: {
      new: 'Vincular módulo'
    }
  },
  users: {
    labels: {
      new: 'Novo usuário'
    }
  },
  form: {
    title: 'Cadastro de Cliente'
  },
  tabs: {
    registration: 'Cadastro',
    ownership: 'Propriedade',
    products: 'Produtos e módulos',
    access: 'Usuários e acesso',
    billing: 'Cobrança',
    operation: 'Operação',
  },
  forms: {
    owner: 'Proprietário do cliente',
    ownerTransfer: 'Transferência de propriedade',
    tenantProduct: 'Produto contratado',
    tenantModule: 'Módulo contratado',
    user: 'Usuário do cliente',
    subscription: 'Assinatura'
  },
  groups: {
    identification: 'Identificação e cadastro',
    companyData: 'Dados cadastrais',
    tenantControl: 'Controle do cliente',
    owners: 'Proprietários',
    ownerTransfers: 'Transferências de propriedade',
    entitlements: 'Entitlements',
    tenantProducts: 'Produtos contratados',
    tenantModules: 'Módulos contratados',
    users: 'Usuários',
    roles: 'Perfis',
    permissions: 'Permissões',
    billing: 'Assinatura e cobrança',
    subscriptions: 'Assinaturas',
    invoices: 'Faturas',
    payments: 'Pagamentos',
    provisioning: 'Histórico de provisionamento',
    audit: 'Auditoria'
  },
  fields: {
    tenant: 'Cliente',
    relationship: 'Relacionamento',
    type: 'Tipo',
    status: 'Status',
    users: 'Usuários',
    modules: 'Módulos',
    maxUsers: 'Limite de usuários',
    createdAt: 'Criado em',
    createdBy: 'Criado por',
    updatedAt: 'Atualizado em',
    updatedBy: 'Atualizado por',
    deletedAt: 'Excluído em',
    deletedBy: 'Excluído por',
    reactivatedAt: 'Reativado em',
    reactivatedBy: 'Reativado por',
    companyName: 'Razão social / nome',
    tradeName: 'Nome fantasia',
    country: 'País',
    document: 'Documento',
    documentNumber: 'Número',
    stateRegistration: 'Inscrição estadual / regional',
    municipalRegistration: 'Inscrição municipal / local',
    foundationDate: 'Data de fundação',
    owner: 'Proprietário',
    currentOwner: 'Proprietário atual',
    requestedOwner: 'Novo proprietário',
    primary: 'Principal',
    revoked: 'Revogado',
    startAt: 'Início',
    revokedAt: 'Revogado em',
    revokedBy: 'Revogado por',
    requestType: 'Tipo de transferência',
    requestStatus: 'Situação',
    reasonKey: 'Motivo',
    reasonNotes: 'Observações',
    product: 'Produto',
    module: 'Módulo',
    modulePath: 'Path',
    active: 'Ativo',
    domainAccessMode: 'Acesso a domínios',
    user: 'Usuário',
    userType: 'Tipo de usuário',
    fullName: 'Nome completo',
    socialName: 'Nome social',
    email: 'E-mail',
    password: 'Senha inicial',
    role: 'Perfil',
    permission: 'Permissão',
    description: 'Descrição',
    subscription: 'Assinatura',
    billingPeriod: 'Periodicidade',
    billingState: 'Situação',
    discount: 'Desconto',
    startDate: 'Início',
    trialEndAt: 'Fim do trial',
    renewsAt: 'Renova em',
    canceledAt: 'Cancelada em',
    invoice: 'Fatura',
    amount: 'Valor',
    currency: 'Moeda',
    issuedAt: 'Emitida em',
    dueAt: 'Vencimento',
    provider: 'Provedor',
    paidAt: 'Pago em',
    source: 'Origem',
    security: 'Segurança',
    billing: 'Cobrança',
    lastError: 'Último erro',
    lastErrorMessage: 'Detalhe do erro',
    lastErrorAt: 'Erro em'
  },
  errors: {
    LOGIN_IDENTIFIER_CONFLICT: 'Este e-mail já está vinculado a outra identidade de acesso.',
    ACCOUNTS_FUNCTIONAL_CONTEXT_UNAVAILABLE: 'Não foi possível validar a identidade de acesso no momento. Tente novamente.',
    PRINCIPAL_CONFLICT: 'O usuário já está vinculado a outro cliente.',
    ACCESS_SYNC_PRINCIPAL_NOT_FOUND: 'A identidade de acesso deste usuário está inconsistente e precisa ser reconciliada.',
    SECURITY_IDENTITY_SYNC_FAILED: 'Não foi possível sincronizar a identidade de acesso.',
    SECURITY_ACCESS_SYNC_FAILED: 'Não foi possível sincronizar o estado de acesso.',
    OWNER_REQUIRED_FIELDS: 'Informe o cliente e o proprietário.',
    OWNER_TARGET_USER_INVALID: 'Escolha um usuário ativo deste cliente.',
    OWNER_ALREADY_ACTIVE: 'Este usuário já é proprietário do cliente.',
    OWNER_NOT_ACTIVE: 'Este proprietário já foi revogado e não pode mais ser alterado. Para devolver a propriedade, use "Transferir propriedade".',
    OWNER_USER_IMMUTABLE: 'Não é possível trocar o usuário de um proprietário existente.',
    OWNER_PRIMARY_REQUIRED: 'O cliente precisa ter um proprietário principal.',
    OWNER_LAST_ACTIVE: 'O cliente precisa ter ao menos um proprietário ativo.',
    OWNER_PRIMARY_REPLACEMENT_REQUIRED: 'Para revogar o proprietário principal, defina antes outro principal.',
    OWNER_TRANSFER_REQUIRED_FIELDS: 'Informe o novo proprietário e o motivo da transferência.',
    CURRENT_OWNER_NOT_FOUND: 'Este cliente não tem um proprietário principal ativo.',
    OWNER_TRANSFER_SAME_USER: 'Este usuário já é o proprietário principal.',
    OWNER_TRANSFER_REQUEST_NOT_FOUND: 'Transferência não encontrada.',
    OWNER_TRANSFER_INVALID_TRANSITION: 'Esta transferência não pode mudar para a situação escolhida.',
    OWNER_TRANSFER_CURRENT_OWNER_CHANGED: 'O proprietário mudou desde o registro desta transferência. Faça uma nova transferência.'
  },
  fallbacks: {
    clientUnnamed: 'Cliente sem nome',
    userUnnamed: 'Usuário sem nome'
  },
  domainAccessModes: {
    all: 'Todos',
    allowlist: 'Somente lista',
    denylist: 'Exceto lista',
    options: [
      { value: 'all', label: 'Todos' },
      { value: 'allowlist', label: 'Somente lista' },
      { value: 'denylist', label: 'Exceto lista' }
    ]
  },
  billingStates: {
    not_verified: 'Não verificada',
    active: 'Ativa',
    trial: 'Trial',
    paused: 'Pausada',
    canceled: 'Cancelada',
    expired: 'Expirada',
    options: [
      { value: 'not_verified', label: 'Não verificada' },
      { value: 'active', label: 'Ativa' },
      { value: 'trial', label: 'Trial' },
      { value: 'paused', label: 'Pausada' },
      { value: 'canceled', label: 'Cancelada' },
      { value: 'expired', label: 'Expirada' }
    ]
  },
  billingPeriods: {
    monthly: 'Mensal',
    annual: 'Anual',
    options: [
      { value: 'monthly', label: 'Mensal' },
      { value: 'annual', label: 'Anual' }
    ]
  },
  ownerRequestTypes: {
    voluntary_transfer: 'Transferência voluntária',
    forced_transfer: 'Transferência forçada',
    company_sale: 'Venda da empresa',
    termination: 'Desligamento',
    death: 'Falecimento',
    security_recovery: 'Recuperação de segurança',
    judicial_order: 'Ordem judicial',
    platform_override: 'Intervenção da Platform',
    options: [
      { value: 'voluntary_transfer', label: 'Transferência voluntária' },
      { value: 'forced_transfer', label: 'Transferência forçada' },
      { value: 'company_sale', label: 'Venda da empresa' },
      { value: 'termination', label: 'Desligamento' },
      { value: 'death', label: 'Falecimento' },
      { value: 'security_recovery', label: 'Recuperação de segurança' },
      { value: 'judicial_order', label: 'Ordem judicial' },
      { value: 'platform_override', label: 'Intervenção da Platform' }
    ]
  },
  ownerRequestStatuses: {
    draft: 'Rascunho',
    requested: 'Solicitada',
    approved: 'Aprovada',
    rejected: 'Rejeitada',
    executed: 'Executada',
    cancelled: 'Cancelada',
    options: [
      { value: 'requested', label: 'Solicitada' },
      { value: 'approved', label: 'Aprovada' },
      { value: 'rejected', label: 'Rejeitada' },
      { value: 'executed', label: 'Executada' },
      { value: 'cancelled', label: 'Cancelada' }
    ]
  }
};
